import { inject } from 'vue';
import type Modals from './modals';

export const modalsKey = Symbol.for('modals');

export default function(): Modals {
  return inject<Modals>(modalsKey)!;
}
